import SignUp from './Pages/SignUp';
import SignUpTwo from './Pages/SignUpTwo';
import SignUpThree from './Pages/SignUpThree';
import { SuggestibleRouteInterface } from '../_Global/Types/RouteTypes';

const SignUpRoutes: Array<SuggestibleRouteInterface> = [
	{
		title: 'Sign Up',
		path: '/signup',
		element: <SignUp />,
		skipSuggestion: true,
	},
	{
		title: 'Sign Up 2',
		path: '/signup2',
		element: <SignUpTwo />,
		skipSuggestion: true,
	},
	{
		title: 'Sign Up 3',
		path: '/signup3',
		element: <SignUpThree />,
		skipSuggestion: true,
	},
];

export default SignUpRoutes;
